import { render } from "./CartItemMoreAction.vue?vue&type=template&id=2e656f2e&scoped=true"
import script from "./CartItemMoreAction.vue?vue&type=script&lang=js"
export * from "./CartItemMoreAction.vue?vue&type=script&lang=js"

import "./CartItemMoreAction.vue?vue&type=style&index=0&id=2e656f2e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e656f2e"]])

export default __exports__